// extracted by mini-css-extract-plugin
export default {"skipLink":"SkipLink-module__skipLink__sgodo"};